export default "__VITE_ASSET__CM42qXsy__"